
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 13","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 7.25v.96L.047 11.938l-.024-.046C0 11.844 0 11.797 0 11.75V1.25A.73.73 0 01.21.734.763.763 0 01.75.5H3c.188 0 .375.094.516.234.14.141.234.329.234.516V2H2.437c-.046 0-.093.023-.14.07-.047.047-.047.07-.047.118v.374c0 .047 0 .094.047.141.047.047.094.047.14.047H3.75v1.5H2.437c-.046 0-.093.023-.14.07-.047.047-.047.07-.047.117v.375c0 .047 0 .094.047.141.047.047.094.047.14.047H3.75v1.5H2.437c-.046 0-.093.023-.14.07-.047.047-.047.07-.047.117v.375c0 .047 0 .094.047.141.047.047.094.047.14.047H3.75zm7.5 1.5c.188 0 .375.094.516.234.14.141.234.329.234.516v2.25a.763.763 0 01-.75.75H.75c-.047 0-.094 0-.14-.023l-.047-.024L4.288 8.75h.961v1.313c0 .046 0 .093.047.14.047.047.094.047.14.047h.375c.047 0 .07 0 .118-.047.047-.047.07-.094.07-.14V8.75h1.5v1.313c0 .046 0 .093.047.14.047.047.094.047.14.047h.375c.047 0 .07 0 .118-.047.047-.047.07-.094.07-.14V8.75h1.5v1.313c0 .046 0 .093.047.14.047.047.094.047.14.047h.376c.046 0 .07 0 .117-.047s.07-.094.07-.14V8.75h.75z","opacity":".6"}})])
          )
        }
      }
    